/* eslint eqeqeq: 'off' */
import {loginUnSuccessFull,passwordExpired,APInotresponding,Forbidden,ErrorSatus} from '../action/authenticateUser';


export function global_error_handling(response) {
    return function (dispatch) {
        if (response !== undefined && response.hasOwnProperty('data')) {
            if (response.data.hasOwnProperty('error')) {
                if (response.status == 401 && response.data.code == 6 && response.data.error == "InvalidCredentials") {  //Invalid Credentials or Un Successful Login
                    dispatch(loginUnSuccessFull());
                }
                else if (response.status == 401 && response.data.code == 13 && response.data.error == "PasswordExpired") {  //Password Expired
                    dispatch(passwordExpired());
                }
            }
            if (response.status == 401) {                                                // 500 or 502 (Connection Error, Bad Gateway), If there is connectivity problem with the Server
                dispatch(loginUnSuccessFull());
            }
            else if (response.status == 500 || response.status == 502 || response.status == 400) {                                                // 500 or 502 (Connection Error, Bad Gateway), If there is connectivity problem with the Server
                dispatch(APInotresponding());
            }
            else if (response.status == 403) {                                                                         // 403, if user is forbidden
                dispatch(Forbidden());
            }
            
            if(response.status !== 200)
                dispatch(ErrorSatus(response.status));
        }
        else if(response !== undefined && response ===false){
            dispatch(APInotresponding());
            dispatch(ErrorSatus('UnKnown'));
        }
        // else {
        //     return true;
        // }
    }

}
